import { observeOpenlayersObject } from "../utils";
import { IMapMeasuringService } from "./types";
import { ol_Feature, ol_Coordinate, ol_geom, ol_Map, ol_Overlay } from "@omnia/exports/openlayers";

/** @internal */
export class MeasureOverlay {

    private overlay: ol_Overlay;
    private watcher: Function;


    constructor(private feature: ol_Feature, private length: boolean, private _olmap: ol_Map, private _measuringSvc: IMapMeasuringService, watchChanges: boolean) {

        this.overlay = this.createMeasureOverlay(this.length);

        let update = () => this.updateOverlay(this.length, this.feature, this.overlay);

        update();

        if (watchChanges) {
            this.watcher = observeOpenlayersObject(this.feature, "change", update);
        }

    }


    dispose() {

        if (this.watcher) {
            this.watcher();
            this.watcher = null;
        }

        if (this.overlay) {
            this._olmap.removeOverlay(this.overlay);
            this.overlay = null;
        }

    }


    private createMeasureOverlay(length: boolean) {

        let element = <HTMLElement>document.createElement("div");
        element.className = "measure";

        let overlay = new ol_Overlay({
            element: element,
            stopEvent: false,
            offset: [0, -15],
            positioning: length ? "bottom-center" : "center-center",
        });

        this._olmap.addOverlay(overlay);

        return overlay;

    }

    private updateOverlay(length: boolean, feature: ol_Feature, overlay: ol_Overlay) {

        let element = <HTMLElement>overlay.getElement();
        let coord: number[];
        let text: string;

        let geom = feature.getGeometry();

        if (geom instanceof ol_geom.Polygon) {

            coord = geom.getInteriorPoint().getCoordinates();

            let area = this.measureArea(geom);
            text = area ? area.text : null;

            let length = this.measureLength(geom);
            if (length) {
                text = (text ? text + "<br>" : "") + length.text;
            }

        }
        else if (geom instanceof ol_geom.LineString) {
            coord = geom.getLastCoordinate();
            let length = this.measureLength(geom);
            text = length ? length.text : null;
        }

        overlay.setPosition(coord);
        element.innerHTML = text;

    }


    private measureArea(geom: ol_geom.Polygon) {
        let area = this._measuringSvc.getArea(geom);
        return {
            area: area,
            text: Math.round(area / 100) / 100 + " ha"
        };
    }

    private measureLength(geom: ol_geom.Geometry) {

        let coords: ol_Coordinate[];
        let polygon = false;

        if (geom instanceof ol_geom.Polygon) {
            let ring = geom.getLinearRing(0);
            coords = ring ? ring.getCoordinates() : null;
            polygon = true;
        }
        else if (geom instanceof ol_geom.LineString) {
            coords = geom.getCoordinates();
        }

        if (coords && (coords.length > 1)) {

            let lastIndex = coords.length - 1;

            if (polygon && (lastIndex > 1)) {

                if (!this.compareCoordinates(coords[0], coords[lastIndex])) {
                    coords.push(coords[0]);
                    lastIndex++;
                }

            }

            let lengths = coords.map((coord, index) => {
                if (index < lastIndex) {
                    let next = coords[index + 1];
                    return this._measuringSvc.getDistance(next, coord) || 0;
                }
            }).filter(l => !!l);

            if (lengths.length) {

                let length = lengths.reduce((l1, l2) => l1 + l2);

                return {
                    length: length,
                    text: Math.round(length) + " m",
                }

            }


        }

    }

    private compareCoordinates(c1: number[], c2: number[]) {
        return (c1 && c2 && (c1.length == 2) && (c2.length == 2) && (c1[0] == c2[0]) && (c1[1] == c2[1]));
    }


}

